import React from 'react'
import Fragment from '../common/fragment'


function FragmentBV(props) {
  return (
    <Fragment pos="vv" {...props}>
      <p>
      ¿Qué es el negro?
      </p>
    </Fragment>
  )
}


export default FragmentBV
